import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { ChangeDetectorRef, Component, OnInit, ViewChildren } from '@angular/core';
import { MatDialog } from '@angular/material';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Guid } from 'guid-typescript';
import html2canvas from 'html2canvas';
import { ContentChange } from 'ngx-quill';
import { PrinterService } from 'src/app/provider/printer.service';
import { MenuItemModel } from 'src/app/views/models/menu-item.model';
import { MenuAsideService, SubheaderService } from '../../../../core/_base/layout';
import { TranslateModel } from '../../../../core/_base/layout/models/translate.model';
import { AppHotelService } from '../../../../provider/app-hotel.service';
import { AWSService } from '../../../../provider/aws.service';
import { ItemService } from '../../../../provider/item.service';
import { PaymentProviderService } from '../../../../provider/payment-provider.service';
import { SurveyResearchService } from '../../../../provider/survey-research.service';
import { TranslationService } from '../../../../provider/translation.service';
import { UserService } from '../../../../provider/user.service';
import { LanguageTranslatePopup } from '../../../component/popup/language-translate/language-translate.popup';
import { SelectSectionPopup } from '../../../component/popup/select-section/select-section.popup';
import { AppHotelModel } from '../../../models/app-hotel.model';
import { MenuTitleDescriptionModel } from '../../../models/menu-title-description.model';
import { SednaSetupModel } from '../../../models/sedna-setup.model';
import { SednaTraceModel } from '../../../models/sedna-trace.model';
import { UserModel } from '../../../models/user.model';
import { TokenFormModel } from '../../auth/models/tokenform.model';


interface Marker {
  lat: number;
  lng: number;
  label?: string;
  draggable: boolean;
}

interface LanguageFlag {
  lang: string;
  name: string;
  flag: string;
  active?: boolean;
}

@Component({
  selector: 'c-hotel-info',
  templateUrl: './hotel-info.page.html',
  styleUrls: ['./hotel-info.page.scss']
})
export class HotelInfoPage implements OnInit {

  constructor(
    public myService: AppHotelService,
    private menuAsideService: MenuAsideService,
    private subheaderService: SubheaderService,
    public userService: UserService,
    private readonly changeDetectorRef: ChangeDetectorRef,
    public tra: TranslationService,
    public awsService: AWSService,
    public itemService: ItemService,
    private modalService: NgbModal,
    public dialog: MatDialog,
    public surveyResearchService: SurveyResearchService,
    public router: Router,
    private cd: ChangeDetectorRef,
    public paymentProviderServ: PaymentProviderService,
    public printerServ: PrinterService
  ) {
    this.subheaderService.title$.next({ title: 'Hotel Information', desc: '', backUrl: '/home/info' });
    this.menuAsideService.pathname$.next(window.location.pathname);

    this.surveyResearchService.getSurveyResearch();
  }

  @ViewChildren('bannerdiv') bannerdiv;
  hotelId: number;
  dataSource: AppHotelModel = new AppHotelModel();
  entegrationData: SednaSetupModel = new SednaSetupModel();
  zoom = 19;
  marker: Marker;
  fa: boolean;
  ar: boolean;
  de: boolean;
  fr: boolean;
  ru: boolean;
  en: boolean;
  tr: boolean;
  es: boolean;
  hotels = [];
  group_hotels = [];
  allSections = [];

  // Notify Users Array
  notifyUsers: { name: string; mail: string; id: number; }[] = [];

  correctionLevel = 'M';

  modules = {
    toolbar: [
      ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
      ['blockquote', 'code-block'],
      [{ list: 'ordered' }, { list: 'bullet' }],
      [{ indent: '-1' }, { indent: '+1' }],          // outdent/indent
      [{ direction: 'rtl' }],                         // text direction
      [{ size: ['small', false, 'large', 'huge'] }],  // custom dropdown
      [{ color: [] }, { background: [] }],          // dropdown with defaults from theme
      [{ align: [] }],
      ['clean'],                                         // remove formatting button
      ['link', 'image', 'video']                         // link and image, video
    ]
  };
  currentAppHotelModel: AppHotelModel;

  selectedLang: LanguageFlag;

  timezone = [
    'GMT',
    'GMT-01:00',
    'GMT-02:00',
    'GMT-03:00',
    'GMT-03:30',
    'GMT-04:00',
    'GMT-04:30',
    'GMT-05:00',
    'GMT-06:00',
    'GMT-07:00',
    'GMT-08:00',
    'GMT-09:00',
    'GMT-10:00',
    'GMT-11:00',
    'GMT-12:00',
    'GMT+01:00',
    'GMT+02:00',
    'GMT+03:00',
    'GMT+03:30',
    'GMT+04:00',
    'GMT+04:30',
    'GMT+05:00',
    'GMT+05:30',
    'GMT+05:45',
    'GMT+06:00',
    'GMT+06:30',
    'GMT+07:00',
    'GMT+08:00',
    'GMT+08:45',
    'GMT+09:00',
    'GMT+09:30',
    'GMT+10:00',
    'GMT+10:30',
    'GMT+11:00',
    'GMT+11:30',
    'GMT+12:00',
    'GMT+12:45',
    'GMT+13:00',
    'GMT+14:00'
  ]

  defaultName: TranslateModel = new TranslateModel();
  defaultLanguages: LanguageFlag[] = [
    {
      lang: 'tr',
      name: 'Türkçe',
      flag: './assets/media/flags/006-turkey.svg'
    },
    {
      lang: 'en',
      name: 'English',
      flag: './assets/media/flags/012-uk.svg'
    },
    {
      lang: 'ru',
      name: 'Russian',
      flag: './assets/media/flags/013-russia.svg'
    },
    {
      lang: 'fr',
      name: 'French',
      flag: './assets/media/flags/019-france.svg'
    },
    {
      lang: 'de',
      name: 'German',
      flag: './assets/media/flags/017-germany.svg'
    },
    {
      lang: 'ar',
      name: 'Arabic',
      flag: './assets/media/flags/008-saudi-arabia.svg'
    },
    {
      lang: 'fa',
      name: 'Persian',
      flag: './assets/media/flags/021-iran.svg'
    },
    {
      lang: 'es',
      name: 'Spanish',
      flag: './assets/media/flags/016-spain.svg'
    },
  ];

  days: any = {
    type: 'select',
    name: 'Show Until x Days Before Check-in Date',
    controlName: 'showUntil',
    value: '0',
    options: [
      {
        value: '0',
        name: 'Always Visible'
      },
      {
        value: '1',
        name: '1 Day'
      },
      {
        value: '2',
        name: '2 Days'
      },
      {
        value: '3',
        name: '3 Days'
      },
      {
        value: '4',
        name: '4 Days'
      },
      {
        value: '5',
        name: '5 Days'
      },
      {
        value: '6',
        name: '6 Days'
      },

      {
        value: '7',
        name: '7 Days'
      },
      {
        value: '8',
        name: '8 Days'
      },
      {
        value: '9',
        name: '9 Days'
      },
      {
        value: '10',
        name: '10 Days'
      },
      {
        value: '11',
        name: '11 Days'
      },
      {
        value: '12',
        name: '12 Days'
      },
      {
        value: '13',
        name: '13 Days'
      },
      {
        value: '14',
        name: '14 Days'
      },
      {
        value: '15',
        name: '15 Days'
      },
      {
        value: '16',
        name: '16 Days'
      },
      {
        value: '17',
        name: '17 Days'
      },
      {
        value: '18',
        name: '18 Days'
      },
      {
        value: '19',
        name: '19 Days'
      },
      {
        value: '20',
        name: '20 Days'
      },
      {
        value: '21',
        name: '21 Days'
      },
      {
        value: '22',
        name: '22 Days'
      },
      {
        value: '23',
        name: '23 Days'
      },
      {
        value: '24',
        name: '24 Days'
      },
      {
        value: '25',
        name: '25 Days'
      },
      {
        value: '26',
        name: '26 Days'
      },
      {
        value: '27',
        name: '27 Days'
      },
      {
        value: '28',
        name: '28 Days'
      },
      {
        value: '29',
        name: '29 Days'
      },
      {
        value: '30',
        name: '30 Days'
      }
    ]
  };

  paymentProviders = [
    {
      name: 'Ziraat Bank',
      controlName: 'ziraat',
      values: [
        {
          type: 'name',
          name: 'Name',
          controlName: 'name',
          value: null
        },
        this.days,
        {
          type: 'text',
          name: 'Username',
          controlName: 'user_name',
          value: null
        },
        {
          type: 'text',
          name: 'Password',
          controlName: 'password',
          value: null
        },
        {
          type: 'text',
          name: 'Client Id',
          controlName: 'sub_merchant_id',
          value: null
        },
        {
          type: 'text',
          name: 'Secure Key',
          controlName: 'secret_key',
          value: null
        },
        {
          type: 'checkbox',
          name: 'Use 3D',
          controlName: 'use_3_d',
          value: false
        },
        {
          type: 'select',
          name: 'Server',
          controlName: 'server',
          value: 'live',
          options: [
            {
              value: 'live',
              name: 'Live'
            },
            {
              value: 'test',
              name: 'Test'
            },
            {
              value: 'development',
              name: 'Development'
            }
          ]
        },
        {
          type: 'checkbox',
          name: 'Default',
          controlName: 'default',
          value: false
        },
        {
          type: 'array',
          name: 'Supported Currencies',
          controlName: 'supported_currencies',
          value: ['TRY', 'EUR', 'USD']
        },
        {
          type: 'text-group',
          value: [
            {
              name: 'Upfront',
              value: null
            }
          ]
        }
      ]
    },
    {
      name: 'QNB Finansbank',
      controlName: 'finansbank',
      values: [
        {
          type: 'name',
          name: 'Name',
          controlName: 'name',
          value: null
        },
        this.days,
        {
          type: 'text',
          name: 'Client Id',
          controlName: 'sub_merchant_id',
          value: null
        },
        {
          type: 'text',
          name: 'User Code',
          controlName: 'terminal_id',
          value: null
        },
        {
          type: 'text',
          name: 'Password',
          controlName: 'password',
          value: null
        },
        {
          type: 'checkbox',
          name: 'Use 3D',
          controlName: 'use_3_d',
          value: false
        },
        {
          type: 'text',
          name: 'Merchant Pass',
          controlName: 'merchant_pass',
          value: null
        },
        {
          type: 'select',
          name: 'Server',
          controlName: 'server',
          value: 'live',
          options: [
            {
              value: 'live',
              name: 'Live'
            },
            {
              value: 'test',
              name: 'Test'
            },
            {
              value: 'development',
              name: 'Development'
            }
          ]
        },
        {
          type: 'checkbox',
          name: 'Default',
          controlName: 'default',
          value: false
        },
        {
          type: 'array',
          name: 'Supported Currencies',
          controlName: 'supported_currencies',
          value: ['TRY', 'EUR', 'USD']
        },
        {
          type: 'text-group',
          value: [
            {
              name: 'Upfront',
              value: null
            }
          ]
        }
      ]
    },
    {
      name: 'Vakıfbank',
      controlName: 'vakifbank',
      values: [
        {
          type: 'name',
          name: 'Name',
          controlName: 'name',
          value: null
        },
        this.days,
        {
          type: 'text',
          name: 'Client Id',
          controlName: 'sub_merchant_id',
          value: null
        },
        {
          type: 'text',
          name: 'Terminal',
          controlName: 'terminal_id',
          value: null
        },
        {
          type: 'text',
          name: 'Terminal Password',
          controlName: 'merchant_pass',
          value: null
        },
        {
          type: 'checkbox',
          name: 'Use 3D',
          controlName: 'use_3_d',
          value: false
        },
        {
          type: 'select',
          name: 'Server',
          controlName: 'server',
          value: 'live',
          options: [
            {
              value: 'live',
              name: 'Live'
            },
            {
              value: 'test',
              name: 'Test'
            },
            {
              value: 'development',
              name: 'Development'
            }
          ]
        },
        {
          type: 'checkbox',
          name: 'Default',
          controlName: 'default',
          value: false
        },
        {
          type: 'array',
          name: 'Supported Currencies',
          controlName: 'supported_currencies',
          value: ['TRY', 'EUR', 'USD']
        },
        {
          type: 'text-group',
          value: [
            {
              name: 'Upfront',
              value: null
            }
          ]
        }
      ]
    },
    {
      name: 'İş Bankasi',
      controlName: 'isbankasi',
      values: [
        {
          type: 'name',
          name: 'Name',
          controlName: 'name',
          value: null
        },
        this.days,
        {
          type: 'text',
          name: 'Username',
          controlName: 'user_name',
          value: null
        },
        {
          type: 'text',
          name: 'Password',
          controlName: 'password',
          value: null
        },
        {
          type: 'text',
          name: 'Client Id',
          controlName: 'sub_merchant_id',
          value: null
        },
        {
          type: 'text',
          name: 'Secure Key',
          controlName: 'secret_key',
          value: null
        },
        {
          type: 'checkbox',
          name: 'Use 3D',
          controlName: 'use_3_d',
          value: false
        },
        {
          type: 'select',
          name: 'Server',
          controlName: 'server',
          value: 'live',
          options: [
            {
              value: 'live',
              name: 'Live'
            },
            {
              value: 'test',
              name: 'Test'
            },
            {
              value: 'development',
              name: 'Development'
            }
          ]
        },
        {
          type: 'checkbox',
          name: 'Default',
          controlName: 'default',
          value: false
        },
        {
          type: 'array',
          name: 'Supported Currencies',
          controlName: 'supported_currencies',
          value: ['TRY', 'EUR', 'USD']
        },
        {
          type: 'text-group',
          value: [
            {
              name: 'Upfront',
              value: null
            }
          ]
        }
      ]
    },
    {
      name: 'Halkbank',
      controlName: 'halkbank',
      values: [
        {
          type: 'name',
          name: 'Name',
          controlName: 'name',
          value: null
        },
        this.days,
        {
          type: 'text',
          name: 'Username',
          controlName: 'user_name',
          value: null
        },
        {
          type: 'text',
          name: 'Password',
          controlName: 'password',
          value: null
        },
        {
          type: 'text',
          name: 'Client Id',
          controlName: 'sub_merchant_id',
          value: null
        },
        {
          type: 'text',
          name: 'Secure Key',
          controlName: 'secret_key',
          value: null
        },
        {
          type: 'checkbox',
          name: 'Use 3D',
          controlName: 'use_3_d',
          value: false
        },
        {
          type: 'select',
          name: 'Server',
          controlName: 'server',
          value: 'live',
          options: [
            {
              value: 'live',
              name: 'Live'
            },
            {
              value: 'test',
              name: 'Test'
            },
            {
              value: 'development',
              name: 'Development'
            }
          ]
        },
        {
          type: 'checkbox',
          name: 'Default',
          controlName: 'default',
          value: false
        },
        {
          type: 'array',
          name: 'Supported Currencies',
          controlName: 'supported_currencies',
          value: ['TRY', 'EUR', 'USD']
        },
        {
          type: 'text-group',
          value: [
            {
              name: 'Upfront',
              value: null
            }
          ]
        }
      ]
    },
    {
      name: 'Akbank',
      controlName: 'akbank',
      values: [
        {
          type: 'name',
          name: 'Name',
          controlName: 'name',
          value: null
        },
        this.days,
        {
          type: 'text',
          name: 'Username',
          controlName: 'user_name',
          value: null
        },
        {
          type: 'text',
          name: 'Password',
          controlName: 'password',
          value: null
        },
        {
          type: 'text',
          name: 'Client Id',
          controlName: 'sub_merchant_id',
          value: null
        },
        {
          type: 'text',
          name: 'Secure Key',
          controlName: 'secret_key',
          value: null
        },
        {
          type: 'checkbox',
          name: 'Use 3D',
          controlName: 'use_3_d',
          value: false
        },
        {
          type: 'select',
          name: 'Server',
          controlName: 'server',
          value: 'live',
          options: [
            {
              value: 'live',
              name: 'Live'
            },
            {
              value: 'test',
              name: 'Test'
            },
            {
              value: 'development',
              name: 'Development'
            }
          ]
        },
        {
          type: 'checkbox',
          name: 'Default',
          controlName: 'default',
          value: false
        },
        {
          type: 'array',
          name: 'Supported Currencies',
          controlName: 'supported_currencies',
          value: ['TRY', 'EUR', 'USD']
        },
        {
          type: 'text-group',
          value: [
            {
              name: 'Upfront',
              value: null
            }
          ]
        }
      ]
    },
    {
      name: 'Garanti',
      controlName: 'garanti',
      values: [
        {
          type: 'name',
          name: 'Name',
          controlName: 'name',
          value: null
        },
        this.days,
        {
          type: 'text',
          name: 'Username',
          controlName: 'user_name',
          value: null
        },
        {
          type: 'text',
          name: 'Password',
          controlName: 'password',
          value: null
        },
        {
          type: 'text',
          name: 'Terminal Id',
          controlName: 'terminal_id',
          value: null
        },
        {
          type: 'text',
          name: 'Merchant Id',
          controlName: 'sub_merchant_id',
          value: null
        },
        {
          type: 'text',
          name: 'Secure Key',
          controlName: 'secret_key',
          value: null
        },
        {
          type: 'checkbox',
          name: 'Use 3D',
          controlName: 'use_3_d',
          value: false
        },
        {
          type: 'checkbox',
          name: 'Default',
          controlName: 'default',
          value: false
        },
        {
          type: 'array',
          name: 'Supported Currencies',
          controlName: 'supported_currencies',
          value: ['TRY', 'EUR', 'USD']
        },
        {
          type: 'select',
          name: 'Server',
          controlName: 'server',
          value: 'live',
          options: [
            {
              value: 'live',
              name: 'Live'
            },
            {
              value: 'test',
              name: 'Test'
            },
            {
              value: 'development',
              name: 'Development'
            }
          ]
        },
        {
          type: 'text-group',
          value: [
            {
              name: 'Upfront',
              value: null
            }
          ]
        }
      ]
    },
    {
      name: 'Paypal',
      controlName: 'paypal',
      values: [
        {
          type: 'name',
          name: 'Name',
          controlName: 'name',
          value: null
        },
        this.days,
        {
          type: 'text',
          name: 'Client Id',
          controlName: 'sub_merchant_id',
          value: null
        },
        {
          type: 'text',
          name: 'Client Secret',
          controlName: 'secret_key',
          value: null
        },
        {
          type: 'select',
          name: 'Server',
          controlName: 'server',
          value: 'live',
          options: [
            {
              value: 'live',
              name: 'Live'
            },
            {
              value: 'test',
              name: 'Test'
            },
            {
              value: 'development',
              name: 'Development'
            }
          ]
        },
        {
          type: 'array',
          name: 'Supported Currencies',
          controlName: 'supported_currencies',
          value: ['TRY', 'EUR', 'USD']
        }
      ]
    },
    {
      name: 'Payby.Me',
      controlName: 'paybyme',
      values: [
        {
          type: 'name',
          name: 'Name',
          controlName: 'name',
          value: null
        },
        this.days,
        {
          type: 'text',
          name: 'Username',
          controlName: 'user_name',
          value: null
        },
        {
          type: 'text',
          name: 'Password',
          controlName: 'password',
          value: null
        },
        {
          type: 'text',
          name: 'Secret Key',
          controlName: 'secret_key',
          value: null
        },
        {
          type: 'select',
          name: 'Server',
          controlName: 'server',
          value: 'live',
          options: [
            {
              value: 'live',
              name: 'Live'
            },
            {
              value: 'test',
              name: 'Test'
            },
            {
              value: 'development',
              name: 'Development'
            }
          ]
        },
        {
          type: 'array',
          name: 'Supported Currencies',
          controlName: 'supported_currencies',
          value: ['TRY', 'EUR', 'USD']
        }
      ]
    },
    {
      name: 'Wirecard',
      controlName: 'wirecard',
      values: [
        {
          type: 'name',
          name: 'Name',
          controlName: 'name',
          value: null
        },
        this.days,
        {
          type: 'text',
          name: 'User Code',
          controlName: 'user_code',
          value: null
        },
        {
          type: 'text',
          name: 'Pin',
          controlName: 'pin',
          value: null
        },
        {
          type: 'text',
          name: 'Submerchant Id',
          controlName: 'sub_merchant_id',
          value: null
        }
      ]
    },
    {
      name: 'Garantipay',
      controlName: 'garantipay',
      values: [
        {
          type: 'name',
          name: 'Name',
          controlName: 'name',
          value: null
        },
        this.days,
        {
          type: 'text',
          name: 'Username',
          controlName: 'user_name',
          value: null
        },
        {
          type: 'text',
          name: 'Password',
          controlName: 'password',
          value: null
        },
        {
          type: 'text',
          name: 'Terminal Id',
          controlName: 'terminal_id',
          value: null
        },
        {
          type: 'text',
          name: 'Merchant Id',
          controlName: 'sub_merchant_id',
          value: null
        },
        {
          type: 'text',
          name: 'Secure Key',
          controlName: 'secret_key',
          value: null
        },
        {
          type: 'select',
          name: 'Server',
          controlName: 'server',
          value: 'live',
          options: [
            {
              value: 'live',
              name: 'Live'
            },
            {
              value: 'test',
              name: 'Test'
            },
            {
              value: 'development',
              name: 'Development'
            }
          ]
        },
        {
          type: 'checkbox',
          name: 'Bonus Usage',
          controlName: 'bonusUsage',
          value: false
        },
        {
          type: 'checkbox',
          name: 'Firm-based Bonus Usage',
          controlName: 'firmbonusUsage',
          value: false
        },
        {
          type: 'checkbox',
          name: 'Cheque Usage',
          controlName: 'chequeUsage',
          value: false
        },
        {
          type: 'checkbox',
          name: 'Mile Usage',
          controlName: 'mileUsage',
          value: false
        },
        {
          type: 'text-group',
          value: [
            {
              name: 'Upfront',
              value: null
            }
          ]
        }
      ]
    },
    {
      name: 'Bank Transfer',
      controlName: 'transfer',
      values: [
        {
          type: 'text',
          name: 'Account Owner',
          controlName: 'owner',
          value: null
        },
        {
          type: 'select',
          name: 'Supported Currencies',
          controlName: 'supported_currencies',
          options: [
            {
              value: 'TRY',
              name: 'TRY'
            },
            {
              value: 'USD',
              name: 'USD'
            },
            {
              value: 'EUR',
              name: 'EUR'
            },
            {
              value: 'RUB',
              name: 'RUB'
            }]
        },
        {
          type: 'text',
          name: 'Bank Name',
          controlName: 'bankName',
          value: null
        },
        {
          type: 'text',
          name: 'Branch Name',
          controlName: 'branchName',
          value: null
        },
        {
          type: 'text',
          name: 'Branch Code',
          controlName: 'branchCode',
          value: null
        },
        {
          type: 'text',
          name: 'Swift Code',
          controlName: 'swiftCode',
          value: null
        },
        {
          type: 'text',
          name: 'IBAN',
          controlName: 'iban',
          value: null
        },
        {
          type: 'text',
          name: 'Account Number',
          controlName: 'accountNumber',
          value: null
        }
      ]
    },
    {
      name: 'Mail Order',
      controlName: 'mailorder',
      values: [
        {
          type: 'name',
          name: 'Name',
          controlName: 'name',
          value: null
        },

        this.days,
        {
          type: 'rich-text',
          name: 'Description',
          controlName: 'description',
          value: null
        },
        {
          type: 'array',
          name: 'Supported Credit Cards',
          value: ['Visa', 'Mastercard', 'Maestro']
        },
        {
          type: 'array',
          name: 'Supported Currencies',
          controlName: 'supported_currencies',
          value: ['TRY', 'EUR', 'USD']
        }
      ]
    },
    {
      name: 'Iyzico',
      controlName: 'iyzico',
      values: [
        {
          type: 'name',
          name: 'Name',
          controlName: 'name',
          value: null
        },
        this.days,
        {
          type: 'rich-text',
          name: 'Description',
          controlName: 'description',
          value: null
        },
        {
          type: 'text',
          name: 'Api Key',
          controlName: 'api_key',
          value: null
        },
        {
          type: 'text',
          name: 'Secret Key',
          controlName: 'secret_key',
          value: null
        },
        {
          type: 'select',
          name: 'Server',
          controlName: 'server',
          value: 'live',
          options: [
            {
              value: 'live',
              name: 'Live'
            },
            {
              value: 'test',
              name: 'Test'
            },
            {
              value: 'development',
              name: 'Development'
            }
          ]
        }
      ]
    },
    {
      name: 'Stripe',
      controlName: 'stripe',
      values: [
        {
          type: 'name',
          name: 'Name',
          controlName: 'name',
          value: null
        },
        this.days,
        {
          type: 'text',
          name: 'Live Secret Key',
          controlName: 'secret_key',
          value: null
        },
        {
          type: 'text',
          name: 'Live Key',
          controlName: 'secret_key',
          value: null
        },
        {
          type: 'text',
          name: 'Test Secret Key',
          controlName: 'test_secret_key',
          value: null
        },
        {
          type: 'text',
          name: 'Test Key',
          controlName: 'test_key',
          value: null
        },
        {
          type: 'checkbox',
          name: 'Payment Profile Support',
          controlName: 'payment_profile_support',
          value: false
        },
        {
          type: 'checkbox',
          name: 'Test Mode',
          controlName: 'testMode',
          value: false
        }
      ]
    },
    {
      name: 'UnionPay',
      controlName: 'unionPay',
      values: [
        {
          type: 'name',
          name: 'Name',
          controlName: 'name',
          value: null
        },
        this.days,
        {
          type: 'text',
          name: 'Username',
          controlName: 'user_name',
          value: null
        },
        {
          type: 'text',
          name: 'Password',
          controlName: 'password',
          value: null
        },
        {
          type: 'text',
          name: 'Client Id',
          controlName: 'sub_merchant_id',
          value: null
        },
        {
          type: 'text',
          name: 'Secure Key',
          controlName: 'secret_key',
          value: null
        },
        {
          type: 'array',
          name: 'Supported Currencies',
          controlName: 'supported_currencies',
          value: ['TRY', 'EUR', 'USD']
        },
        {
          type: 'select',
          name: 'Server',
          controlName: 'server',
          value: 'live',
          options: [
            {
              value: 'live',
              name: 'Live'
            },
            {
              value: 'test',
              name: 'Test'
            },
            {
              value: 'development',
              name: 'Development'
            }
          ]
        }
      ]
    },
  ];

  integrationProvider = [
    {
      name: 'PMS - OPERA ONPREMISE',
      controlName: 'operaOnpremise',
      values: [
        {
          type: 'text',
          name: 'Grant Type Delegation Client ID',
          controlName: 'sub_merchant_id',
          value: null
        },
        {
          type: 'text',
          name: 'Grant Type Delegation Client Secret',
          controlName: 'secret_key',
          value: null
        },
        {
          type: 'text',
          name: 'Grant Type Password Client ID',
          controlName: 'sub_merchant_idPassword',
          value: null
        },
        {
          type: 'text',
          name: 'Grant Type Password Client Secret',
          controlName: 'secret_keyPassword',
          value: null
        },
        {
          type: 'text',
          name: 'Scope',
          controlName: 'scope',
          value: null
        },
        {
          type: 'text',
          name: 'API Key',
          controlName: 'api_key',
          value: null
        },
        {
          type: 'text',
          name: 'Company ID',
          controlName: 'companyId',
          value: null
        },
        {
          type: 'checkbox',
          name: 'Test Mode',
          controlName: 'testMode',
          value: false
        }
      ]
    },
    {
      name: 'PMS - OPERA HOSTED',
      controlName: 'operaHosted',
      values: [
        {
          type: 'text',
          name: 'Grant Type Delegation Client ID',
          controlName: 'sub_merchant_id',
          value: null
        },
        {
          type: 'text',
          name: 'Grant Type Delegation Client Secret',
          controlName: 'secret_key',
          value: null
        },
        {
          type: 'text',
          name: 'Grant Type Password Client ID',
          controlName: 'sub_merchant_idPassword',
          value: null
        },
        {
          type: 'text',
          name: 'Grant Type Password Client Secret',
          controlName: 'secret_keyPassword',
          value: null
        },
        {
          type: 'text',
          name: 'Scope',
          controlName: 'scope',
          value: null
        },
        {
          type: 'text',
          name: 'API Key',
          controlName: 'api_key',
          value: null
        },
        {
          type: 'text',
          name: 'Company ID',
          controlName: 'companyId',
          value: null
        },
        {
          type: 'checkbox',
          name: 'Test Mode',
          controlName: 'testMode',
          value: false
        }
      ]
    },
    {
      name: 'PMS - SUITE8 ONPREMISE',
      controlName: 'suite8Onpremise',
      values: [
        {
          type: 'text',
          name: 'Grant Type Delegation Client ID',
          controlName: 'sub_merchant_id',
          value: null
        },
        {
          type: 'text',
          name: 'Grant Type Delegation Client Secret',
          controlName: 'secret_key',
          value: null
        },
        {
          type: 'text',
          name: 'Grant Type Password Client ID',
          controlName: 'sub_merchant_idPassword',
          value: null
        },
        {
          type: 'text',
          name: 'Grant Type Password Client Secret',
          controlName: 'secret_keyPassword',
          value: null
        },
        {
          type: 'text',
          name: 'Scope',
          controlName: 'scope',
          value: null
        },
        {
          type: 'text',
          name: 'API Key',
          controlName: 'api_key',
          value: null
        },
        {
          type: 'text',
          name: 'Company ID',
          controlName: 'companyId',
          value: null
        },
        {
          type: 'checkbox',
          name: 'Test Mode',
          controlName: 'testMode',
          value: false
        }
      ]
    },
    {
      name: 'PMS - MEWS',
      controlName: 'mews',
      values: [
        {
          type: 'text',
          name: 'Grant Type Delegation Client ID',
          controlName: 'sub_merchant_id',
          value: null
        },
        {
          type: 'text',
          name: 'Grant Type Delegation Client Secret',
          controlName: 'secret_key',
          value: null
        },
        {
          type: 'text',
          name: 'Grant Type Password Client ID',
          controlName: 'sub_merchant_idPassword',
          value: null
        },
        {
          type: 'text',
          name: 'Grant Type Password Client Secret',
          controlName: 'secret_keyPassword',
          value: null
        },
        {
          type: 'text',
          name: 'Scope',
          controlName: 'scope',
          value: null
        },
        {
          type: 'text',
          name: 'API Key',
          controlName: 'api_key',
          value: null
        },
        {
          type: 'text',
          name: 'Company ID',
          controlName: 'companyId',
          value: null
        },
        {
          type: 'checkbox',
          name: 'Test Mode',
          controlName: 'testMode',
          value: false
        }
      ]
    },
    {
      name: 'PMS - CLOCK PMS',
      controlName: 'clock',
      values: [
        {
          type: 'text',
          name: 'Grant Type Delegation Client ID',
          controlName: 'sub_merchant_id',
          value: null
        },
        {
          type: 'text',
          name: 'Grant Type Delegation Client Secret',
          controlName: 'secret_key',
          value: null
        },
        {
          type: 'text',
          name: 'Grant Type Password Client ID',
          controlName: 'sub_merchant_idPassword',
          value: null
        },
        {
          type: 'text',
          name: 'Grant Type Password Client Secret',
          controlName: 'secret_keyPassword',
          value: null
        },
        {
          type: 'text',
          name: 'Scope',
          controlName: 'scope',
          value: null
        },
        {
          type: 'text',
          name: 'API Key',
          controlName: 'api_key',
          value: null
        },
        {
          type: 'text',
          name: 'Company ID',
          controlName: 'companyId',
          value: null
        },
        {
          type: 'checkbox',
          name: 'Test Mode',
          controlName: 'testMode',
          value: false
        }
      ]
    },
    {
      name: 'PMS - GUESTLINE',
      controlName: 'guestline',
      values: [
        {
          type: 'text',
          name: 'Grant Type Delegation Client ID',
          controlName: 'sub_merchant_id',
          value: null
        },
        {
          type: 'text',
          name: 'Grant Type Delegation Client Secret',
          controlName: 'secret_key',
          value: null
        },
        {
          type: 'text',
          name: 'Grant Type Password Client ID',
          controlName: 'sub_merchant_idPassword',
          value: null
        },
        {
          type: 'text',
          name: 'Grant Type Password Client Secret',
          controlName: 'secret_keyPassword',
          value: null
        },
        {
          type: 'text',
          name: 'Scope',
          controlName: 'scope',
          value: null
        },
        {
          type: 'text',
          name: 'API Key',
          controlName: 'api_key',
          value: null
        },
        {
          type: 'text',
          name: 'Company ID',
          controlName: 'companyId',
          value: null
        },
        {
          type: 'checkbox',
          name: 'Test Mode',
          controlName: 'testMode',
          value: false
        }
      ]
    },
    {
      name: 'PMS - PROTEL ONPREMISE',
      controlName: 'protelOnpremise',
      values: [
        {
          type: 'text',
          name: 'Grant Type Delegation Client ID',
          controlName: 'sub_merchant_id',
          value: null
        },
        {
          type: 'text',
          name: 'Grant Type Delegation Client Secret',
          controlName: 'secret_key',
          value: null
        },
        {
          type: 'text',
          name: 'Grant Type Password Client ID',
          controlName: 'sub_merchant_idPassword',
          value: null
        },
        {
          type: 'text',
          name: 'Grant Type Password Client Secret',
          controlName: 'secret_keyPassword',
          value: null
        },
        {
          type: 'text',
          name: 'Scope',
          controlName: 'scope',
          value: null
        },
        {
          type: 'text',
          name: 'API Key',
          controlName: 'api_key',
          value: null
        },
        {
          type: 'text',
          name: 'Company ID',
          controlName: 'companyId',
          value: null
        },
        {
          type: 'checkbox',
          name: 'Test Mode',
          controlName: 'testMode',
          value: false
        }
      ]
    },
    {
      name: 'PMS - INFOR HMS',
      controlName: 'inforHms',
      values: [
        {
          type: 'text',
          name: 'Grant Type Delegation Client ID',
          controlName: 'sub_merchant_id',
          value: null
        },
        {
          type: 'text',
          name: 'Grant Type Delegation Client Secret',
          controlName: 'secret_key',
          value: null
        },
        {
          type: 'text',
          name: 'Grant Type Password Client ID',
          controlName: 'sub_merchant_idPassword',
          value: null
        },
        {
          type: 'text',
          name: 'Grant Type Password Client Secret',
          controlName: 'secret_keyPassword',
          value: null
        },
        {
          type: 'text',
          name: 'Scope',
          controlName: 'scope',
          value: null
        },
        {
          type: 'text',
          name: 'API Key',
          controlName: 'api_key',
          value: null
        },
        {
          type: 'text',
          name: 'Company ID',
          controlName: 'companyId',
          value: null
        },
        {
          type: 'checkbox',
          name: 'Test Mode',
          controlName: 'testMode',
          value: false
        }
      ]
    },
    {
      name: 'PMS - SEDNA',
      controlName: 'sedna',
      values: [
        {
          type: 'text',
          name: 'Grant Type Delegation Client ID',
          controlName: 'sub_merchant_id',
          value: null
        },
        {
          type: 'text',
          name: 'Grant Type Delegation Client Secret',
          controlName: 'secret_key',
          value: null
        },
        {
          type: 'text',
          name: 'Grant Type Password Client ID',
          controlName: 'sub_merchant_idPassword',
          value: null
        },
        {
          type: 'text',
          name: 'Grant Type Password Client Secret',
          controlName: 'secret_keyPassword',
          value: null
        },
        {
          type: 'text',
          name: 'Scope',
          controlName: 'scope',
          value: null
        },
        {
          type: 'text',
          name: 'API Key',
          controlName: 'api_key',
          value: null
        },
        {
          type: 'text',
          name: 'Company ID',
          controlName: 'companyId',
          value: null
        },
        {
          type: 'checkbox',
          name: 'Test Mode',
          controlName: 'testMode',
          value: false
        }
      ]
    },
    {
      name: 'Devops - Firebase',
      controlName: 'firebase',
      values: [
        {
          type: 'text',
          name: 'Grant Type Delegation Client ID',
          controlName: 'sub_merchant_id',
          value: null
        },
        {
          type: 'text',
          name: 'Grant Type Delegation Client Secret',
          controlName: 'secret_key',
          value: null
        },
        {
          type: 'text',
          name: 'Grant Type Password Client ID',
          controlName: 'sub_merchant_idPassword',
          value: null
        },
        {
          type: 'text',
          name: 'Grant Type Password Client Secret',
          controlName: 'secret_keyPassword',
          value: null
        },
        {
          type: 'text',
          name: 'Scope',
          controlName: 'scope',
          value: null
        },
        {
          type: 'text',
          name: 'API Key',
          controlName: 'api_key',
          value: null
        },
        {
          type: 'text',
          name: 'Company ID',
          controlName: 'companyId',
          value: null
        },
        {
          type: 'checkbox',
          name: 'Test Mode',
          controlName: 'testMode',
          value: false
        }
      ]
    },
    {
      name: 'Devops - AWS',
      controlName: 'aws',
      values: [
        {
          type: 'text',
          name: 'Grant Type Delegation Client ID',
          controlName: 'sub_merchant_id',
          value: null
        },
        {
          type: 'text',
          name: 'Grant Type Delegation Client Secret',
          controlName: 'secret_key',
          value: null
        },
        {
          type: 'text',
          name: 'Grant Type Password Client ID',
          controlName: 'sub_merchant_idPassword',
          value: null
        },
        {
          type: 'text',
          name: 'Grant Type Password Client Secret',
          controlName: 'secret_keyPassword',
          value: null
        },
        {
          type: 'text',
          name: 'Scope',
          controlName: 'scope',
          value: null
        },
        {
          type: 'text',
          name: 'API Key',
          controlName: 'api_key',
          value: null
        },
        {
          type: 'text',
          name: 'Company ID',
          controlName: 'companyId',
          value: null
        },
        {
          type: 'checkbox',
          name: 'Test Mode',
          controlName: 'testMode',
          value: false
        }
      ]
    },
    {
      name: 'Communication - SendGrid',
      controlName: 'sendGrid',
      values: [
        {
          type: 'text',
          name: 'Grant Type Delegation Client ID',
          controlName: 'sub_merchant_id',
          value: null
        },
        {
          type: 'text',
          name: 'Grant Type Delegation Client Secret',
          controlName: 'secret_key',
          value: null
        },
        {
          type: 'text',
          name: 'Grant Type Password Client ID',
          controlName: 'sub_merchant_idPassword',
          value: null
        },
        {
          type: 'text',
          name: 'Grant Type Password Client Secret',
          controlName: 'secret_keyPassword',
          value: null
        },
        {
          type: 'text',
          name: 'Scope',
          controlName: 'scope',
          value: null
        },
        {
          type: 'text',
          name: 'API Key',
          controlName: 'api_key',
          value: null
        },
        {
          type: 'text',
          name: 'Company ID',
          controlName: 'companyId',
          value: null
        },
        {
          type: 'checkbox',
          name: 'Test Mode',
          controlName: 'testMode',
          value: false
        }
      ]
    },
    {
      name: 'Communication - twillo',
      controlName: 'twillo',
      values: [
        {
          type: 'text',
          name: 'Grant Type Delegation Client ID',
          controlName: 'sub_merchant_id',
          value: null
        },
        {
          type: 'text',
          name: 'Grant Type Delegation Client Secret',
          controlName: 'secret_key',
          value: null
        },
        {
          type: 'text',
          name: 'Grant Type Password Client ID',
          controlName: 'sub_merchant_idPassword',
          value: null
        },
        {
          type: 'text',
          name: 'Grant Type Password Client Secret',
          controlName: 'secret_keyPassword',
          value: null
        },
        {
          type: 'text',
          name: 'Scope',
          controlName: 'scope',
          value: null
        },
        {
          type: 'text',
          name: 'API Key',
          controlName: 'api_key',
          value: null
        },
        {
          type: 'text',
          name: 'Company ID',
          controlName: 'companyId',
          value: null
        },
        {
          type: 'checkbox',
          name: 'Test Mode',
          controlName: 'testMode',
          value: false
        }
      ]
    },
    {
      name: 'Communication - PostaGüvercini',
      controlName: 'postaGuvercini',
      values: [
        {
          type: 'text',
          name: 'Grant Type Delegation Client ID',
          controlName: 'sub_merchant_id',
          value: null
        },
        {
          type: 'text',
          name: 'Grant Type Delegation Client Secret',
          controlName: 'secret_key',
          value: null
        },
        {
          type: 'text',
          name: 'Grant Type Password Client ID',
          controlName: 'sub_merchant_idPassword',
          value: null
        },
        {
          type: 'text',
          name: 'Grant Type Password Client Secret',
          controlName: 'secret_keyPassword',
          value: null
        },
        {
          type: 'text',
          name: 'Scope',
          controlName: 'scope',
          value: null
        },
        {
          type: 'text',
          name: 'API Key',
          controlName: 'api_key',
          value: null
        },
        {
          type: 'text',
          name: 'Company ID',
          controlName: 'companyId',
          value: null
        },
        {
          type: 'checkbox',
          name: 'Test Mode',
          controlName: 'testMode',
          value: false
        }
      ]
    },
    {
      name: 'Communication - MailChimp',
      controlName: 'mailChimp',
      values: [
        {
          type: 'text',
          name: 'Grant Type Delegation Client ID',
          controlName: 'sub_merchant_id',
          value: null
        },
        {
          type: 'text',
          name: 'Grant Type Delegation Client Secret',
          controlName: 'secret_key',
          value: null
        },
        {
          type: 'text',
          name: 'Grant Type Password Client ID',
          controlName: 'sub_merchant_idPassword',
          value: null
        },
        {
          type: 'text',
          name: 'Grant Type Password Client Secret',
          controlName: 'secret_keyPassword',
          value: null
        },
        {
          type: 'text',
          name: 'Scope',
          controlName: 'scope',
          value: null
        },
        {
          type: 'text',
          name: 'API Key',
          controlName: 'api_key',
          value: null
        },
        {
          type: 'text',
          name: 'Company ID',
          controlName: 'companyId',
          value: null
        },
        {
          type: 'checkbox',
          name: 'Test Mode',
          controlName: 'testMode',
          value: false
        }
      ]
    },
  ];

  // Notify Users Array
  notifyUserLevelOne: { name: string; mail: string; id: number; }[] = [];
  notifyUserLevelTwo: { name: string; mail: string; id: number; }[] = [];
  notifyUserLevelThree: { name: string; mail: string; id: number; }[] = [];
  notifyUserLevelFour: { name: string; mail: string; id: number; }[] = [];
  notifyUserLevelFive: { name: string; mail: string; id: number; }[] = [];
  allUsers: UserModel[] = [];

  savedPayment = JSON.parse(localStorage.getItem('savedPayments')) || [];
  savedIntegrations = JSON.parse(localStorage.getItem('savedIntegrations')) || [];
  savedtaxs = JSON.parse(localStorage.getItem('savedTaxs')) || [];
  savedReceipts = JSON.parse(localStorage.getItem('savedReceipts')) || [];
  profile: TokenFormModel = JSON.parse(localStorage.getItem('token_form'));

  currentBank: any = { controlName: '' };
  currentIntegration: any = { controlName: '' };
  taxs: any = {
    name: this.defaultName,
    includePrice: false,
    taxRate: 0
  };

  menuItemId: number = null;

  currentBankIndex: number = null;
  userLang = localStorage.getItem('language') || 'en';
  languages: LanguageFlag[] = [];
  separatorKeysCodes = [ENTER, COMMA];

  filteredData = true;

  sedna_trace_maps: SednaTraceModel[];
  titleDess: MenuTitleDescriptionModel[];

  currentMenuTitleDescriptionModel: MenuTitleDescriptionModel;

  last: HTMLElement = null;

  /* QR CODE VARIABLES AND FUNCTIONS */
  showImage = false;
  imageData: string[] = [null, null, null, null];
  bannerIndex: number = null;

  refresh() {
    this.cd.detectChanges();
  }

  async ngOnInit() {

    try {
      await this.printerServ.getLocalPrinters();
    } catch { }

    if (this.myService.popupHotelId) {
      this.hotelId = this.myService.popupHotelId;
    }

    console.log(this.myService.popupHotelId);


    if (!this.hotelId) {
      this.hotelId = JSON.parse(localStorage.getItem('token_form')).app_hotel_id;
    }

    try {
      this.myService.getHotelInfo(this.hotelId).subscribe(
        async (data: AppHotelModel) => {

          this.dataSource = data;
          this.languages = [];
          try {
            this.defaultLanguages.forEach(x => {
              if (data.languages.includes(x.lang)) {
                if (x.lang === this.tra.getSelectedLanguage()) {
                  x.active = true;
                  this.selectedLang = x;
                } else {
                  x.active = false;
                }
                this.languages.push(x);
              }
            });
          } catch {
          }
          this.awsService.getImages(this.dataSource.id, 'Slider');
          const lng = this.dataSource.languages.split(',');
          lng.forEach(x => {
            switch (x) {
              case 'tr':
                this.tr = true;
                break;
              case 'en':
                this.en = true;
                break;
              case 'fr':
                this.fr = true;
                break;
              case 'ru':
                this.ru = true;
                break;
              case 'de':
                this.de = true;
                break;
              case 'ar':
                this.ar = true;
                break;
              case 'fa':
                this.fa = true;
                break;
              case 'es':
                this.es = true;
                break;
            }
          });
          this.myService.getHotelImage(this.dataSource.id, 'Slider');
          this.myService.getHotelImage(this.dataSource.id, 'Logo');
          this.myService.getHotelImage(this.dataSource.id, 'LightLogo');
          this.myService.getHotelImage(this.dataSource.id, 'DarkLogo');
          this.changeDetectorRef.markForCheck();
          this.subheaderService.title$.next({ title: this.dataSource.name, desc: '' });

          if (this.dataSource.group_hotels != undefined) {
            this.group_hotels = this.dataSource.group_hotels.split(',');
          }
          this.itemService.getHotelTitleandDes(this.dataSource.id);

          this.allUsers = await this.userService.getUsersPromise() as UserModel[];

          this.updateAlertList();
        },
        err => console.error(err)
      );

      this.hotels = this.profile.app_hotels.split(',');
      this.hotels.forEach(x => x.split('|'));

      const ITEMS = await this.itemService.getItemsWithSectionId(157) as MenuItemModel[];
      this.menuItemId = ITEMS[0].id;

      if (ITEMS[0].user_ids_for_notifications && ITEMS[0].user_ids_for_notifications.split(';')
        && ITEMS[0].user_ids_for_notifications.split(';').length > 0) {
        this.notifyUsers = [];
        for (const id of ITEMS[0].user_ids_for_notifications.split(';')) {
          if (id !== 'undefined' && id) {
            const USER = this.allUsers.find(x => x.id === Number(id));
            console.log(USER);
            this.notifyUsers.push({
              id: USER.id,
              mail: USER.email,
              name: `${USER.name} ${USER.last_name}`
            });
          }
        }

        console.log(this.notifyUsers);
      }
    } catch {
    }

    this.paymentProviderServ.getPayment();
  }

  async updateAlertList() {
    try {

      this.notifyUserLevelOne = [];
      this.notifyUserLevelTwo = [];
      this.notifyUserLevelThree = [];
      this.notifyUserLevelFour = [];
      this.notifyUserLevelFive = [];

      if (this.dataSource.first_level_alert_list) {
        for (const id of this.dataSource.first_level_alert_list.split(';')) {
          if (id !== 'undefined' && id) {
            const USER = this.allUsers.find(x => x.id === Number(id));
            this.notifyUserLevelOne.push({
              id: USER.id,
              mail: USER.email,
              name: `${USER.name} ${USER.last_name}`
            });
          }
        }
      }

      if (this.dataSource.second_level_alert_list) {
        for (const id of this.dataSource.second_level_alert_list.split(';')) {
          if (id !== 'undefined' && id) {
            const USER = this.allUsers.find(x => x.id === Number(id));
            this.notifyUserLevelTwo.push({
              id: USER.id,
              mail: USER.email,
              name: `${USER.name} ${USER.last_name}`
            });
          }
        }
      }

      if (this.dataSource.third_level_alert_list) {
        for (const id of this.dataSource.third_level_alert_list.split(';')) {
          if (id !== 'undefined' && id) {
            const USER = this.allUsers.find(x => x.id === Number(id));
            this.notifyUserLevelThree.push({
              id: USER.id,
              mail: USER.email,
              name: `${USER.name} ${USER.last_name}`
            });
          }
        }
      }

      if (this.dataSource.fourth_level_alert_list) {
        for (const id of this.dataSource.fourth_level_alert_list.split(';')) {
          if (id !== 'undefined' && id) {
            const USER = this.allUsers.find(x => x.id === Number(id));
            this.notifyUserLevelFour.push({
              id: USER.id,
              mail: USER.email,
              name: `${USER.name} ${USER.last_name}`
            });
          }
        }
      }

      if (this.dataSource.negative_survey_alert_list) {
        for (const id of this.dataSource.negative_survey_alert_list.split(';')) {
          if (id !== 'undefined' && id) {
            const USER = this.allUsers.find(x => x.id === Number(id));
            this.notifyUserLevelFive.push({
              id: USER.id,
              mail: USER.email,
              name: `${USER.name} ${USER.last_name}`
            });
          }
        }
      }

    } catch {
    }
  }

  putHotelInfo() {
    this.myService.putHotelInfo(this.dataSource);
    console.log(this.dataSource);
  }

  uploadFileSlider(event: any, directory: string) {
    if (event.target.files && event.target.files.length > 0) {
      for (const file of event.target.files) {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          const guid = Guid.create();
          this.awsService.uploadImage(file, this.dataSource.id, directory, guid + '.jpg').subscribe(
            (resp) => {
              console.log(resp);
              this.awsService.getImages(this.dataSource.id, directory);
            }
          );
        };
      }
    }
  }

  edit(data: any, modal: any, index: number, current: any) {
    this.currentBankIndex = index;
    switch (current) {
      case 'currentBank':
        this.currentBank = data;
        this.open(modal, 'capacity-modal');
        break;
      case 'currentIntegration':
        this.currentIntegration = data;
        this.open(modal, 'capacity-modal');
        break;
      case 'taxs':
        this.taxs = data;
        this.open(modal, 'tax-modal');
        break;
    }
  }

  setBank(value: any) {
    for (const provider of this.paymentProviders) {
      if (provider.controlName === value) {
        this.currentBank = provider;
        break;
      }
    }
  }

  savePayment() {
    if (this.currentBank.active === undefined) {
      this.currentBank.active = false;
      this.savedPayment.push(this.currentBank);
    } else {
      this.savedPayment[this.currentBankIndex] = this.currentBank;
    }

    this.savedPayment.forEach(payment => {
      payment.values.forEach(value => {
        if (value.name === 'Supported Currencies') {
          this.currentBank.currencies = value.value;
        }

        if (value.controlName === 'default') {
          this.currentBank.isDefault = value.value;
        }
      });
    });

    localStorage.setItem('savedPayments', JSON.stringify(this.savedPayment));
    this.savedPayment = JSON.parse(localStorage.getItem('savedPayments'));

    this.currentBank = { controlName: '' };
  }

  change(index: string, el: any) {
    const navs = document.getElementsByClassName('left-nav') as any;
    const tab = document.getElementById(`tab-${index}`);
    const first = document.getElementById(`tab-2`);


    for (const element of navs) {
      if (element.classList.contains('active')) {
        element.classList.remove('active');
      }
    }

    if (this.last !== null) {
      this.last.style.display = 'none';
      this.last = tab;
    } else {
      first.style.display = 'none';
      this.last = tab;
    }
    el.classList.add('active');
    first.style.display = 'none';
    tab.style.display = 'block';
  }

  uploadFileLogo(event: any, directory: string) {
    if (event.target.files && event.target.files.length > 0) {
      for (const file of event.target.files) {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          this.awsService.uploadImage(file, this.dataSource.id, directory, this.dataSource.id + '.jpg').subscribe(
            (resp) => {
              console.log(resp);
              if (directory == 'LightLogo' || directory == 'DarkLogo' || directory == 'Logo') {
                this.myService.getHotelImage(this.dataSource.id, directory);
              } else {
                this.awsService.getImages(this.dataSource.id, directory);
              }
            }
          );
        };
      }
    }
  }

  markerDragEnd(m: Marker, $event: any) {
    this.dataSource.lat_lng = $event.coords.lat + ',' + $event.coords.lng;
    this.putHotelInfo();
  }

  imgUploadClick() {
    document.getElementById('slider').click();
  }

  imgUploadClickLogo(elementID: string) {
    document.getElementById(elementID).click();
  }

  imgUploadClickLightLogo() {
    document.getElementById('lightlogo').click();
  }

  imgUploadClickDarkLogo() {
    document.getElementById('darklogo').click();
  }

  deleteImage(name: string, directory: string) {
    this.awsService.deleteImage(this.dataSource.id, directory, name).subscribe(
      (resp) => {
        this.awsService.getImages(this.dataSource.id, directory);
      }
    );
  }

  Update() {
    this.dataSource.languages = '';
    if (this.tr) {
      this.dataSource.languages += 'tr,';
    }
    if (this.en) {
      this.dataSource.languages += 'en,';
    }
    if (this.ru) {
      this.dataSource.languages += 'ru,';
    }
    if (this.de) {
      this.dataSource.languages += 'de,';
    }
    if (this.fr) {
      this.dataSource.languages += 'fr,';
    }
    if (this.ar) {
      this.dataSource.languages += 'ar,';
    }
    if (this.fa) {
      this.dataSource.languages += 'fa,';
    }
    if (this.es) {
      this.dataSource.languages += 'es';
    }
    this.dataSource.languages.substring(0, -1);
    this.languages = [];
    this.defaultLanguages.forEach(x => {
      if (this.dataSource.languages.includes(x.lang)) {
        x.active = x.lang == this.selectedLang.lang;
        this.languages.push(x);
      }
    });
    this.myService.putHotelInfo(this.dataSource);
  }

  onPointClick(e, interval) {
    this.filteredData = true;
    this.surveyResearchService.filterData(interval, e.target.originalArgument);
  }

  DeleteHotel() {
    this.myService.deleteHotel(this.dataSource.id);
  }

  open(content, modalClass?: string) {
    const windowClass = modalClass || null;
    this.modalService.open(content, { windowClass }).result.then();
  }


  getLocal(local: string): number {
    try {
      if (local == 'lat') {
        return +this.dataSource.lat_lng.split(',')[0];
      } else if (local == 'long') {
        return +this.dataSource.lat_lng.split(',')[1];
      } else {
        return 0;
      }
    } catch {
    }
  }

  openEditMenu() {
    const dialogRef = this.dialog.open(SelectSectionPopup, { width: '1100px', height: '600px' });
    dialogRef.afterClosed().subscribe();
  }

  getHotelId(hotel: any) {
    return hotel.split('|')[0];
  }

  getHotelName(hotel: string) {
    return hotel.split('|')[1];
  }

  GroupHotel() {
    this.dataSource.group_hotels = '';
    this.group_hotels.forEach(x => {
      this.dataSource.group_hotels += x + ',';
    });
    this.dataSource.group_hotels = this.dataSource.group_hotels.slice(0, -1);
    this.myService.putHotelInfo(this.dataSource);
  }

  getText($event: ContentChange) {
    switch (this.selectedLang.lang) {
      case 'tr':
        this.dataSource.hotel_information_tr = $event.html;
        break;
      case 'en':
        this.dataSource.hotel_information_en = $event.html;
        break;
      case 'de':
        this.dataSource.hotel_information_de = $event.html;
        break;
      case 'ru':
        this.dataSource.hotel_information_ru = $event.html;
        break;
      case 'fr':
        this.dataSource.hotel_information_fr = $event.html;
        break;
      case 'ar':
        this.dataSource.hotel_information_ar = $event.html;
        break;
      case 'fa':
        this.dataSource.hotel_information_ir = $event.html;
        break;
      case 'es':
        this.dataSource.hotel_information_es = $event.html;
        break;
    }
    this.myService.putHotelInfo(this.dataSource);
  }

  languageTranslate(baseData: any, key: string, val: string, baseDataType?: string) {
    let translateModel: TranslateModel;
    try {
      translateModel = JSON.parse(val);
    } catch (e) {
      translateModel = new TranslateModel();
    }
    if (baseDataType == 'AppHotel') {
      this.currentAppHotelModel = baseData;
    } else {
      this.currentAppHotelModel = undefined;
    }

    if (baseDataType == 'MenuTitleDescription') {
      this.currentMenuTitleDescriptionModel = baseData;
    } else {
      this.currentMenuTitleDescriptionModel = undefined;
    }

    const dialogRef = this.dialog.open(LanguageTranslatePopup, {
      width: '700px', data: {
        ML: translateModel,
        baseData,
        key,
      },
    });

    dialogRef.afterClosed().subscribe(() => {
      if (baseDataType == 'MenuTitleDescription') {
        if (this.currentMenuTitleDescriptionModel != undefined) {
          this.itemService.putTitleDesData(this.currentMenuTitleDescriptionModel);
          return;
        }
      }
      this.myService.putHotelInfo(this.dataSource);
      if (this.currentAppHotelModel != undefined) {
        this.myService.putHotelInfo(this.currentAppHotelModel);
      }
      this.refresh();
    });

  }

  setLanguage(language: LanguageFlag) {
    this.selectedLang.active = false;
    language.active = true;
    this.selectedLang = language;
  }

  deleteTitleAndDescImg(i: number) {
    const titleDesc = this.itemService.titleDescriptionHotel_change$.getValue();
    titleDesc[i].image_url = '';
    this.itemService.deleteFileonAWS(titleDesc[i]);
    this.itemService.putTitleDesData(titleDesc[i]);
  }

  deleteTitleAndDesc(item: MenuTitleDescriptionModel) {
    this.itemService.deleteTitleDesData(item);
  }

  addTitleAndDesc() {
    const titleandDes = new MenuTitleDescriptionModel();
    titleandDes.hotel_id = this.dataSource.id;
    this.itemService.postTitleDesHotelData(titleandDes);
  }

  uploadTitleFile(event: any, item: MenuTitleDescriptionModel) {
    const selectedFile = event.target.files[0] as File;
    this.itemService.postFile(selectedFile, 'titleDesc', item);
  }

  goProfile(id: any) {
    this.router.navigateByUrl('/activity/profile/' + id);
  }

  filterData(week: string) {
    this.surveyResearchService.filterData(week);
  }

  setupSedna() {
    this.myService.postSednaTraceMap().subscribe(
      (resp) => {
        this.myService.getSednaTraceMaps().subscribe((datas) => {
          this.sedna_trace_maps = datas;
          this.myService.getTraceTitleDescription().subscribe((data) => {
            this.titleDess = data;
          });
        });
      },
      error => {
        console.log(error);
      },
    );
  }

  typeChange(id: any, i: number) {
    this.sedna_trace_maps[i].menu_item_id = this.titleDess.find(x => x.id == id).menu_item_id;
    this.sedna_trace_maps[i].title = this.titleDess.find(x => x.id == id).title;
    this.sedna_trace_maps[i].menu_item_title_and_description_id = +this.sedna_trace_maps[i].menu_item_title_and_description_id;
    this.myService.putTraceTitleDescription(this.sedna_trace_maps[i]);
  }

  getSubType(trace: SednaTraceModel) {
    if (!this.titleDess.find(x => x.id == trace.menu_item_title_and_description_id).select_values) {
      return '';
    }
    switch (localStorage.getItem('language')) {
      case 'tr':
        return JSON.parse(this.titleDess.find(x => x.id == trace.menu_item_title_and_description_id).select_values).tr;
      case 'en':
        return JSON.parse(this.titleDess.find(x => x.id == trace.menu_item_title_and_description_id).select_values).en;
      case 'ru':
        return JSON.parse(this.titleDess.find(x => x.id == trace.menu_item_title_and_description_id).select_values).ru;
    }
  }

  getDate(date: Date): string {
    return new Date(date).toISOString().split('T')[0];
  }

  getTime(date: Date): string {
    return new Date(date).toISOString().split('T')[1].slice(0, 5);
  }

  setDate($newDate: any, type: string, dataSource: AppHotelModel) {
    if (type == 'entry_date') {
      const oldTime = new Date(dataSource.entry_date).toISOString().split('T')[0];
      dataSource.entry_date = new Date(oldTime + 'T' + $newDate.target.value + ':00Z');
    } else if (type == 'release_date') {
      const oldTime = new Date(dataSource.release_date).toISOString().split('T')[0];
      dataSource.release_date = new Date(oldTime + 'T' + $newDate.target.value + ':00Z');
    } else if (type == 'open_date') {
      const newDate = new Date($newDate.target.value).toISOString().split('T')[0];
      const oldTime = new Date(dataSource.open_date).toISOString().split('T')[1];
      dataSource.open_date = new Date(newDate + 'T' + oldTime);
    } else if (type == 'close_date') {
      const newDate = new Date($newDate.target.value).toISOString().split('T')[0];
      const oldTime = new Date(dataSource.close_date).toISOString().split('T')[1];
      dataSource.close_date = new Date(newDate + 'T' + oldTime);
    }
    this.myService.putHotelInfo(dataSource);
  }

  convert(div: HTMLElement, qr: any, image: HTMLElement, index: number) {

    this.refresh();
    const bannerdiv: HTMLElement = document.getElementById('banner-div');
    window.scrollTo(0, 0);
    bannerdiv.style.display = 'flex';

    document.body.append(bannerdiv);

    this.bannerIndex = index;
    const selected = document.getElementById(`banner-${index}`) as HTMLImageElement;

    image.setAttribute('src', selected.src);
    div.classList.remove('preview');
    this.showImage = true;
    const options = {
      dpi: 1500, // Set to 300 DPI
      scrollY: -window.scrollY,
      scrollX: 0,
      allowTaint: true,
      scale: 1.5,
      backgroundColor: null,
      useCORS: true
    };


    setTimeout(() => {
      html2canvas(div, options).then(canvas => {
        this.imageData[index - 1] = canvas.toDataURL('image/png');
        this.convertblob(canvas.toDataURL('image/png'));
        div.classList.add('preview');
      });

      setTimeout(() => {
        this.showImage = false;
        bannerdiv.style.display = 'none';
      }, 100);
    }, 100);

  }

  download(index: number) {
    const link = document.createElement('a');
    link.download = 'html_image.png';
    link.href = this.imageData[index - 1];
    link.target = '_blank';
    link.click();
  }

  convertblob(img: string) {
    const base64ImageData = img;
    const contentType = 'image/png';

    const byteCharacters = atob(base64ImageData.substr(`data:${contentType};base64,`.length));
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += 1024) {
      const slice = byteCharacters.slice(offset, offset + 1024);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);

      byteArrays.push(byteArray);
    }
    const blob = new Blob(byteArrays, { type: contentType });
    const blobUrl = URL.createObjectURL(blob);

    window.open(blobUrl, '_blank');
    this.refresh();
  }

  changeRow(array: any[], item: any, type: string) {
    if (type === 'push') {
      array.push(Object.assign({ name: null, value: null }));
    } else if (type === 'splice') {
      array.splice(item, 1);
    } else if (type === 'push-string') {
      array.push(item);
    }
  }

  pushNotifyUser(id: string, arr: any, key: string) {

    const USER = this.userService.users_change$.getValue().find(x => x.id === Number(id));

    arr.push({
      id: USER.id,
      mail: USER.email,
      name: `${USER.name} ${USER.last_name}`
    });
    let users = '';

    for (const [index, user] of arr.entries()) {
      users += user.id;
      if (index < arr.length - 1) {
        users += ';';
      }
    }
    this.dataSource[`${key}`] = users;

    this.myService.putHotelInfo(this.dataSource);
    this.updateAlertList();
  }

  deleteNotifyUser(id: number, arr: any, key: string) {
    arr = arr.filter(x => x.id != id);

    let users = '';

    for (const [index, USER] of arr.entries()) {
      users += USER.id;
      if (index < arr.length - 1) {
        users += ';';
      }
    }

    this.dataSource[`${key}`] = users;

    this.myService.putHotelInfo(this.dataSource);
    this.updateAlertList();
  }

  deleteItemNotifyUser(id: number) {
    this.notifyUsers = this.notifyUsers.filter(x => x.id != id);

    let users = '';

    for (const [index, user] of this.notifyUsers.entries()) {
      users += user.id;
      if (index < this.notifyUsers.length - 1) {
        users += ';';
      }
    }

    this.itemService.record_change$.getValue().user_ids_for_notifications = users;

    this.itemService.putData(this.itemService.record_change$.getValue());
  }

  pushItemNotifyUser(id: number) {
    const USER = this.userService.users_change$.getValue().find(x => x.id === Number(id));
    this.notifyUsers.push({
      id: USER.id,
      mail: USER.email,
      name: `${USER.name} ${USER.last_name}`
    });
    let users = '';

    for (const [index, user] of this.notifyUsers.entries()) {
      users += user.id;
      if (index < this.notifyUsers.length - 1) {
        users += ';';
      }
    }
    this.itemService.record_change$.getValue().user_ids_for_notifications = users;

    this.itemService.putData(this.itemService.record_change$.getValue());
  }
}
